angular
    .module('quattro.bmbo.email.list', [
        'quattro.core.filters',
        'quattro.core.modal-confirm',
        'quattro.bmbo.email.model',
        'quattro.bmbo.email.modal-edit',
        'quattro.bmbo.email.modal-add',
    ])
    .directive('bmboEmailList', function () {
        return {
            scope: {
                account: '@',
                domain: '@',
            },
            templateUrl: 'bmbo/email/list.html',
            controller: 'bmboEmailListController',
            controllerAs: 'vm',
        };
    })
    .controller('bmboEmailListController', function ($scope, $q, Email, myModalService) {

        var domain = $scope.domain;

        this.loadList = function () {
            var promise = Email.query(domain);
            promise.then(function (result) {
                $scope.emaillist = result;
            });
        };

        this.loadList();

        var listener = (function (e) {
            this.loadList();
        }).bind(this);

        document.addEventListener(
            "email updated",
            listener,
            false
        );

        // triger modal edits

        this.modalAdd = function () {
            $scope.$emit('vq.bmbo.email.add', {domain: domain,}, this.loadList);
        };

        this.modalEdit = function (email) {
            $scope.$emit('vq.bmbo.email.edit', email);
        };

        // manages api calls to delete list of mails, returns promise
        function deleteEmailList(mails) {
            var promisePool = mails.map(function (mail) {
                return new Email({
                    mail: mail,
                }).remove();
            });
            return $q.all(promisePool);
        }

        this.deleteSelected = function () {

            var list = this.emaillistSelected().map(function (value) {
                return value.mail;
            });

            myModalService.showModal({
                templateUrl: 'bmbo/email/modal-confirm-delete.html',
                inputs: {
                    list: list,
                    reload: this.loadList,
                },
                controller: function ($scope, close, list, reload) {
                    $scope.list = list;
                    $scope.cancel = function () {
                        close();
                    };
                    $scope.confirm = function () {
                        close();
                        deleteEmailList(list)
                            .finally(function () {
                                reload();
                                angular.element('.itemlist').removeClass('show-contextual');
                            });
                    };
                },
            });

        };

        // manages api calls to set capabilities for list of emails, returns promise
        function setCapabilitiesEmailList(mail_list, capabilities_checked) {

            var promisePool = mail_list.map(function (mail) {

                var capabilities_mail = new Email({
                    mail: mail.mail,
                }, "read");
                capabilities_mail.loaded = true;

                var capabilites_to_set = [];
                for (var capability in capabilities_checked) {
                    if (capabilities_checked[capability] === 'on') {
                        capabilites_to_set.push(capability);
                    } else if (capabilities_checked[capability] === 'mixed' && mail.capabilities.includes(capability)) {
                        capabilites_to_set.push(capability);
                    }
                }

                capabilities_mail.data.capabilities = capabilites_to_set;
                capabilities_mail.update();
            });
            return $q.all(promisePool);
        }

        this.setCapabilitiesSelected = function () {

            var mail_list = this.emaillistSelected();
            var possible_capabilities = mail_list[0].possible_capabilities;

            // create list with possible capabilities and set capabilities_checked to 0
            var capabilities_checked = {};
            possible_capabilities.forEach(function (capability) {
                capabilities_checked[capability] = 0;
            });

            // get all actual set capabilities from all emails and count occurrence of each capability in capabilities_checked
            var actual_capabilities = this.emaillistSelected().map(function (value) {
                return value.capabilities;
            }).flat();
            actual_capabilities.forEach(function (capability) {
                if (possible_capabilities.includes(capability)) {
                    capabilities_checked[capability] = (capabilities_checked[capability] || 0) + 1;
                }
            });

            // count emails; determine checkbox status by comparing email count with count of each capability
            var emails_count = this.emaillistSelected().length;
            Object.keys(capabilities_checked).forEach(function (capability) {
                if (capabilities_checked[capability] === 0) {
                    capabilities_checked[capability] = 'off';
                } else if (capabilities_checked[capability] === emails_count) {
                    capabilities_checked[capability] = 'on';
                } else if (0 < capabilities_checked[capability] < emails_count) {
                    capabilities_checked[capability] = 'mixed';
                }
            });

            myModalService.showModal({
                templateUrl: 'bmbo/email/modal-email-capabilities-set.html',
                inputs: {
                    mail_list: mail_list,
                    capabilities_checked: capabilities_checked,
                    reload: this.loadList,
                },
                controller: function ($scope, close, mail_list, capabilities_checked, reload) {
                    $scope.mail_list = mail_list;

                    $scope.possible_capabilities = mail_list[0].possible_capabilities;
                    $scope.capabilities_checked = capabilities_checked;
                    $scope.cancel = function () {
                        close();
                    };
                    $scope.cancelconfirm = function () {
                        close();
                    };
                    $scope.confirm = function () {
                        close();

                        setCapabilitiesEmailList(mail_list, $scope.capabilities_checked)
                            .finally(function () {
                                setTimeout(function () {
                                    reload();
                                }, 4000);
                                angular.element('.itemlist').removeClass('show-contextual');
                            });
                    };
                },
            });

        };


        // checkbox selection

        this.emaillistSelected = function () {
            var list = $scope.emaillist;
            var filtered = list.filter(function (item) {
                return item.$checked;
            });
            return filtered.length ? filtered : list;
        };


        // sorting, filter

        this.search = {};

        this.orderByExpression = 'mail';
        this.orderByReverse = false;

        this.orderBy = function (predicate) {
            this.orderByReverse = (this.orderByExpression === predicate) ? !this.orderByReverse : false;
            this.orderByExpression = predicate;
        };
        this.orderedClass = function (predicate) {
            if (this.orderByExpression === predicate) {
                return this.orderByReverse ? 'sort-desc' : 'sort-asc';
            }
            return '';
        };

    });
